var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.633 16C25.207 16 20 21.12 20 27.43c0 2.638.995 4.94 2.433 7.003l9.2 12.868 9.7-13.546a11.27 11.27 0 001.933-6.324c0-6.312-5.208-11.43-11.633-11.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.402 29.844a3.519 3.519 0 01-2.56 1.096c-.981 0-1.9-.401-2.559-1.095a3.438 3.438 0 01-.953-2.372c0-1.92 1.574-3.469 3.508-3.469 1.935 0 3.513 1.549 3.513 3.469 0 .894-.343 1.734-.95 2.37z"
  })))));
};
export default SvgPin;